import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import {CardContent, Paper, Chip} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import Link from '@material-ui/core/Link';
import Carousel from 'react-material-ui-carousel'
import translate from '../other/translate.json';

export default function BannerNew(props) {
  const language = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  const { lang,carouselApps } = props

  function BannerApp (props) {
    let class_ = 'root';
    if (props?.item?.announcement !== '') {
      class_ = 'rootAnonce';
    } 
    if (props?.item?.isNew === 1){
      class_ = 'rootNew';
    }

    const needDesc =(title, desc, customDescription) => {
      if (!!props.item || !!props.item.briefdescription) {
        let hasCustomDesc = customDescription !== null && !!customDescription
        let maxTitleString = Math.ceil(props.item.title.length / 28)
        let maxdescString = Math.ceil(props.item.briefdescription.length / 30)
        let maxCustomDesc = hasCustomDesc ? Math.ceil(customDescription.length / 30) : 0;
        // console.log(props.item.codeasvul,maxTitleString,maxdescString )
        if (hasCustomDesc) {
          
          if (maxTitleString > 5 || maxTitleString === 5 && maxCustomDesc > 4 || maxCustomDesc > 5) {
            //console.log("hasCustomDesc вместо title",hasCustomDesc,maxCustomDesc,maxTitleString , maxdescString )
            return {canRenderDesc:false,title:customDescription,desc} 
          }
          if (maxTitleString < 5 ) {
            //console.log("hasCustomDesc вместо desc",hasCustomDesc,maxCustomDesc,maxTitleString , maxdescString )
            return {canRenderDesc:true,title,desc:customDescription} 
          }

          
        }
        if (maxTitleString > 5 || maxTitleString === 5 && maxdescString > 4 || maxdescString > 5 ) {
          return {canRenderDesc:false,title,desc}
        }
        return {canRenderDesc:true,title,desc}  
      }
      return {canRenderDesc:false,title,desc}
    }

    let {title,desc,canRenderDesc} = needDesc(props.item.title,props.item.briefdescription, props.item.customDescription )

   
		return (
			<Link href ={props.item.isHideAppLink !== 1 ? `/applications/card/${props.item.codeasvul}?isVisitFromBanner=1` : undefined} target="nofolow" underline = "none" >
				<Card className={classes[class_]} >
          <Grid className={classes.opacityContainer}>
					<Chip
            style={{ backgroundColor: '#BCBBD0', cursor: 'pointer' }}
            label={props.item.codeasvul}
            className={classes.chip}
          />
          { props.item.isNew === 1
          ? 
            <Chip
              style={{ backgroundColor: '#81D39D', cursor: 'pointer' }}
              label={translate.Words[`New${language}`]}
              className={classes.chip}
            />
            :
            null
          }
          { props.item.announcement !== ''
          ? 
            <Chip
              style={{ backgroundColor: '#FE9D67', cursor: 'pointer' }}
              label={props.item.announcement}
              className={classes.chip}
            />
            :
            null
          }
          { props.item.isCloudApp === 1 && false
          ? 
            <Chip
              style={{ backgroundColor: '#67C8FE', cursor: 'pointer' }}
              label={translate.Words[`CloudApp_${language}`]}
              className={classes.chip}   
            />
            :
            null
          }
		
					
          <Typography className={classes.Title1}>
              {title}
            </Typography>
            {canRenderDesc ?
              <Typography className={classes.Desc1}>
                {desc}
              </Typography>
              :
              null
            }
			
					{/* <p>{props.item.Title_catalog}</p> */}
					</Grid>
				</Card>
			</Link>
		)
	}
  
  return (
    <Carousel 
        interval = {10000} 
        //onChange={(i, lastI)=>{_activeBanner(carouselAppsDB.map(el => el.codeasvul).indexOf(carouselApps[i].codeasvul))} }
        navButtonsAlwaysInvisible	 ={true} 
        //indicatorContainerProps ={{style:{display:'none'}}}
        autoPlay={true}
        className={classes.banner}
        //index={activeBanner}
        indicatorContainerProps= {{className:classes.indicatorsContainer}}
        indicatorIconButtonProps={{
          style: {
            color:'#fff',
            height:8,width:8
            , padding:'0 11px'
          }
      }}
      activeIndicatorIconButtonProps={{
          style: {
            color: '#3C3C56',
            height:8,width:8 , padding:'0 11px'// 2
          }
      }}
        >
      {
        carouselApps.map( (item, i) => <BannerApp key={i} item={item} /> )
      }
    </Carousel>
  )
}

const useStyles = makeStyles(theme => ({
  banner : {
    [theme.breakpoints.down(696)]: {
      width:336
    }
  },
  opacityContainer:{
    width:'100%',
    height:'100%',
    padding:'32px 24px 24px 60px',
    [theme.breakpoints.between(696, 1032)]: {      
      padding:'24px 24px 24px 32px',
    },
    [theme.breakpoints.down(696)]: {
      backgroundColor:'rgba(255,255,255,0.5)',
      padding:20,
    }
  },
  indicatorsContainer: {
    marginTop:-40, 
    marginBottom:24,
    [theme.breakpoints.between(696, 1032)]: {
      marginTop:-40, marginBottom:24,
    },
    [theme.breakpoints.down(696)]: {
      marginTop:-52, marginBottom:9
    }
  },
  root: {
    borderRadius:24,     
    boxShadow: 'unset',
    height: 368,    
    borderRadius: '24px',
    backgroundImage  : 'url(/currentApp.png)',backgroundSize : /*'1131px 636px'*/'contain',     //backgroundPosition :  '0 -78px',
    [theme.breakpoints.between(696, 1032)]: {
      borderRadius: '15.65px',
      height:240,      
      backgroundSize : 'contain',     //'748.25px 414.78px',    backgroundPosition :'0 -50px',
      //padding:'24px 24px 24px 32px',
    },
    [theme.breakpoints.down(696)]: {
      display: 'block',
      marginBottom: 23,
      height:260,
      borderRadius: '15.65px',
      width:312,
      // opacity:'80%',
      backgroundSize : '696px 260px',    backgroundPosition : '-176px 0',
      //padding:20,
    }
  },
  rootNew: {
    borderRadius:24, //padding:'32px 24px 24px 60px',
    height: 368,    
    borderRadius: '24px',
    backgroundImage  : 'url(/newApp.png)',
    backgroundSize : 'contain',     //'1049px 589px',   backgroundPosition : '-29px -156px',
    [theme.breakpoints.between(696, 1032)]: {
      borderRadius: '15.65px',
      height:240, 
      backgroundSize : 'contain', //'694px 384.13px',   backgroundPosition : '-19.19px -101.74px',   
      //padding:'24px 24px 24px 32px',  
    },
    [theme.breakpoints.down(696)]: {
      display: 'block',
      marginBottom: 23,
      height:260,
      borderRadius: '15.65px',
      width:312,
      // opacity:'80%',
      backgroundSize :     '696px 260px',    backgroundPosition : '-246px 0',
      //padding:20,
    }
  },
  rootAnonce: {
    borderRadius:24,// padding:'32px 24px 24px 60px',
    boxShadow: 'unset',
    height: 368,    
    backgroundImage: 'url(/anonceApp.png)',
    borderRadius: '24px',
    backgroundSize : 'contain',     //'1044px 586px',    backgroundPosition : '0 -121px',
    [theme.breakpoints.between(696, 1032)]: {
      borderRadius: '15.65px',
      height:240,      
      backgroundSize : 'contain',     //'690.7px 382.17px',     backgroundPosition : '0 -78.91px',
      //padding:'24px 24px 24px 32px',
    },
    [theme.breakpoints.down(696)]: {
      display: 'block',
      marginBottom: 23,
      height:260,
      borderRadius: '15.65px',
      width:312,
      // opacity:'80%',
      backgroundSize :     '696px 260px',    backgroundPosition : '-265px 0',
      //padding:20,
    }
  },
  Title1: {
    fontFamily: 'Cera CY',
    boxShadow: 'unset',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '26px',
    lineHeight: '30px',
    color: '#24262A',
    width:420,
    padding:'12px 0 16px 0',
    [theme.breakpoints.between(696, 1032)]: {
      fontSize: '16px',
      lineHeight: '18px',
      display: 'flex',
      alignItems: 'center',
      width:320,
      padding: '8px 0 8px 0'
      
    },

    [theme.breakpoints.down(696)]: {
      fontFamily: 'Cera CY',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '16px',
      width:272,
      padding: '8px 0 8px 0'
      
      
    }
  },
  Desc1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
    color: '#24262A',
    width:420,
    [theme.breakpoints.between(696, 1032)]: {
      fontSize: '13px',
      lineHeight: '16px',
      display: 'flex',
      alignItems: 'center',
      color: '#000000',
      width:320,
    },

    [theme.breakpoints.down(696)]: {
      fontFamily: 'Cera CY',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '28px',
      lineHeight: '36px',
      color: '#000000',
      display:'none'
    }
  },
  chip: {
		height: 24,
		margin: '0 3.5px',
    '&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
    fontFamily: 'Cera CY',
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		//boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},
}));